import axios, { AxiosInstance } from "axios";

import {
    ITenantDataProviderClient,
    TenantDataProviderClient,
    IDriverClient,
    DriverClient,
    IFileClient,
    FileClient,
    CarrierClient,
    ICarrierClient,
    VehicleClient,
    IVehicleClient,
    IntegrationClient,
    IIntegrationClient,
    SettingsClient,
    ISettingsClient,
    RadarClient,
    IRadarClient,
    IBidsClient,
    BidsClient,
    OrderClient,
    IOrderClient,
    INoteClient,
    NoteClient,
    IContactClient,
    ContactClient,
    ITelegramClient,
    TelegramClient,
    PaymentClient,
    IPaymentClient,
    IInvoiceClient,
    InvoiceClient,
    ITrackingDeviceClient,
    TrackingDeviceClient,
    IOrderTaskClient,
    OrderTaskClient,
    IOrderQuoteClient,
    OrderQuoteClient,
    IOwnerAccountClient,
    OwnerAccountClient,
    IMobileClient,
    MobileClient,
    ICompanyIntegrationClient,
    CompanyIntegrationClient,
    IEmailInboxClient,
    EmailInboxClient,
    IDevClient,
    DevClient,
    IRateSettingsClient,
    RateSettingsClient,
    UserClient,
    IUserClient
} from "../api/clients.api";
import { ApiClientConfig } from "app/modules/common/api/ApiClientConfig";

const hostName = window.location.hostname;
export const apiBaseUrl = hostName == 'localhost' ? 'http://localhost:8080' : 'https://' + hostName;

export class ApiClients {
    tenantDataProviderClient: ITenantDataProviderClient = null;
    driverClient: IDriverClient = null;
    fileClient: IFileClient = null;
    noteClient: INoteClient = null;
    carrierClient: ICarrierClient = null;
    vehicleClient: IVehicleClient = null;
    integrationClient: IIntegrationClient = null;
    companyIntegrationClient: ICompanyIntegrationClient = null;
    settingsClient: ISettingsClient = null;
    radarClient: IRadarClient = null;
    bidsClient: IBidsClient = null;
    orderClient: IOrderClient = null;
    contactClient: IContactClient = null;
    telegramClient: ITelegramClient = null;
    paymentClient: IPaymentClient = null;
    invoiceClient: IInvoiceClient = null;
    trackingDeviceClient: ITrackingDeviceClient = null;
    orderTaskClient: IOrderTaskClient = null;
    orderQuoteClient: IOrderQuoteClient = null;
    ownerAccountClient: IOwnerAccountClient = null;
    axiosInstance: AxiosInstance = null;
    mobileClient: IMobileClient = null;
    emailInboxClient: IEmailInboxClient = null;
    devClient: IDevClient = null;
    rateSettingsClient: IRateSettingsClient = null;
    userClient: IUserClient = null;

    constructor(configuration: ApiClientConfig) {
        this.axiosInstance = axios.create({
            baseURL: apiBaseUrl,
            headers: {
                'Content-Type': 'application/json'
            },
            validateStatus: (status) => {
                return status >= 200 && status < 500
            }
        });

        this.axiosInstance.defaults.withCredentials = true;

        this.tenantDataProviderClient = new TenantDataProviderClient(configuration, apiBaseUrl, this.axiosInstance);
        this.driverClient = new DriverClient(configuration, apiBaseUrl, this.axiosInstance);
        this.fileClient = new FileClient(configuration, apiBaseUrl, this.axiosInstance);
        this.noteClient = new NoteClient(configuration, apiBaseUrl, this.axiosInstance);
        this.carrierClient = new CarrierClient(configuration, apiBaseUrl, this.axiosInstance);
        this.vehicleClient = new VehicleClient(configuration, apiBaseUrl, this.axiosInstance);
        this.settingsClient = new SettingsClient(configuration, apiBaseUrl, this.axiosInstance);
        this.radarClient = new RadarClient(configuration, apiBaseUrl, this.axiosInstance);
        this.bidsClient = new BidsClient(configuration, apiBaseUrl, this.axiosInstance);
        this.integrationClient = new IntegrationClient(configuration, apiBaseUrl, this.axiosInstance);
        this.orderClient = new OrderClient(configuration, apiBaseUrl, this.axiosInstance);
        this.contactClient = new ContactClient(configuration, apiBaseUrl, this.axiosInstance);
        this.telegramClient = new TelegramClient(configuration, apiBaseUrl, this.axiosInstance);
        this.paymentClient = new PaymentClient(configuration, apiBaseUrl, this.axiosInstance);
        this.trackingDeviceClient = new TrackingDeviceClient(configuration, apiBaseUrl, this.axiosInstance);
        this.invoiceClient = new InvoiceClient(configuration, apiBaseUrl, this.axiosInstance);
        this.orderQuoteClient = new OrderQuoteClient(configuration, apiBaseUrl, this.axiosInstance);
        this.ownerAccountClient = new OwnerAccountClient(configuration, apiBaseUrl, this.axiosInstance);
        this.orderTaskClient = new OrderTaskClient(configuration, apiBaseUrl, this.axiosInstance);
        this.mobileClient = new MobileClient(configuration, apiBaseUrl, this.axiosInstance);
        this.companyIntegrationClient = new CompanyIntegrationClient(configuration, apiBaseUrl, this.axiosInstance);
        this.emailInboxClient = new EmailInboxClient(configuration, apiBaseUrl, this.axiosInstance);
        this.devClient = new DevClient(configuration, apiBaseUrl, this.axiosInstance);
        this.rateSettingsClient = new RateSettingsClient(configuration, apiBaseUrl, this.axiosInstance);
        this.userClient = new UserClient(configuration, apiBaseUrl, this.axiosInstance);

        this.axiosInstance.interceptors.response.use((response) => {
            if (response.status == 400) {
                if (response.data.ErrorCode == "Maintenance" && response.data.Obj == "Tenant") {
                    window.location.href = "/maintenance";
                    return;
                }
            }

            return response;
        }, (error) => {
            if (error.response?.status == 401) {
                window.location.href = "/";
            }
        });
    }
}


